import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { Observable } from 'rxjs';

export interface AssignLeadsRequest {
    lead_ids?: string[];
    lead_campaign_id?: string;
    leader_id: string;
    member_id?: string;
    quantity?: number;
    note?: string;
    status?: string;
}

export interface ReclaimLeadsRequest {
    lead_campaign_id: string;
    user_id: string;
}

@Injectable({ providedIn: 'root' })
export class LeadAssignApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/lead-assign`;
    }

    assignLeads(body: AssignLeadsRequest): Observable<{ assigned: number; updated?: number; requested?: number; message?: string }> {
        return this.httpClient.post<any>(this.url, body);
    }

    reclaimLeads(body: ReclaimLeadsRequest): Observable<{ reclaimed: number; requested?: number; message?: string }> {
        return this.httpClient.post<any>(`${this.url}/reclaim`, body);
    }

    updateNote(leadId: string, note: string, status?: string): Observable<{ updated: number }> {
        const body: { lead_id: string; note: string; status?: string } = { lead_id: leadId, note };
        if (status) body.status = status;
        return this.httpClient.post<any>(`${this.url}/note`, body);
    }

    getNotesByEmployee(employeeId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/notes/by-employee/${employeeId}`);
    }

    getNotesByLead(leadId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/notes/by-lead/${leadId}`);
    }
}
